import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const PhonebookWiseSurveyVoters = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { appId, language, userId } = useAppId();
    const lang = language || 'en';

    // Renamed variable for clarity
    const admin_id = location.state?.admin_id;

    const [voters, setVoters] = useState([]);
    const [userInfo, setUserInfo] = useState({ name: "", designation: "" });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all"); // 'all', 'P', 'N', 'D', 'C', 'notAvailable'
    const [showDropdown, setShowDropdown] = useState(false);

    // --- NEW: Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50; // Matching reference page

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Phonebook Wise Survey Voters",
            filterPlaceholder: "Filter displayed results by name...",
            loadingData: "Loading Data...",
            noMembers: "No survey records found.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            statusLabel: "Status :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            address: "Address :",
            filterByStatus: "Filter by Status",
            allStatus: "All",
            positive: "Positive",
            negative: "Negative",
            doubtful: "Doubtful",
            notInterested: "Can't Say",
            notAvailable: "Not Available",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!",
            totalRecords: "Total Records"

        },
        hi: {
            pageTitle: "फोनबुक वाइज़ सर्वेक्षण मतदाता",
            filterPlaceholder: "नाम से प्रदर्शित परिणाम फ़िल्टर करें...",
            loadingData: "डेटा लोड हो रहा है...",
            noMembers: "कोई सर्वेक्षण रिकॉर्ड नहीं मिला।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            statusLabel: "स्थिति :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            filterByStatus: "स्थिति के अनुसार फ़िल्टर करें",
            allStatus: "सभी",
            positive: "सकारात्मक",
            negative: "नकारात्मक",
            doubtful: "संदिग्ध",
            notInterested: "कुछ नहीं कह सकते",
            notAvailable: "अनुपलब्ध",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!",
            totalRecords: "कुल रिकॉर्ड"

        },
        gu: {
            pageTitle: "ફોનબુક વાઈઝ સર્વે મતદારો",
            filterPlaceholder: "પ્રદર્શિત પરિણામોને નામથી ફિલ્ટર કરો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noMembers: "કોઈ સર્વે રેકોર્ડ મળ્યા નથી.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            statusLabel: "સ્થિતિ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            address: "સરનામું :",
            filterByStatus: "સ્થિતિ દ્વારા ફિલ્ટર કરો",
            allStatus: "બધા",
            positive: "પોઝિટિવ",
            negative: "નેગેટિવ",
            doubtful: "ડાઉટફુલ",
            notInterested: "કંઈ નહીં",
            notAvailable: "નોટ એવેલેબલ",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!",
            totalRecords: "કુલ રેકોર્ડ"

        }
    };

    const txt = t[lang];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);

    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };

    useEffect(() => {
        if (appId) {
            fetchVoterData();
        } else {
            setLoading(false);
        }
    }, [appId]);

    // Reset to page 1 when searching or filtering
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, statusFilter]);

    const fetchVoterData = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_user_wise_survey_voter`, {
                app_id: appId,
                admin_id: admin_id,
                survey_from: "TF"
            });

            if (response.data.success) {
                const results = response.data.data.result || [];
                setUsersAndInfo(results);
            }
        } catch (error) {
            console.error("Error fetching voter survey details:", error);
        } finally {
            setLoading(false);
        }
    };

    const setUsersAndInfo = (results) => {
        setVoters(results);
        if (results.length > 0) {
            setUserInfo({
                name: results[0].name,
                designation: results[0].designation
            });
        }
    };

    const getStatusStyles = (status) => {
        switch (status) {
            case 'P': return { color: '#10b981', label: txt.positive };
            case 'N': return { color: '#ef4444', label: txt.negative };
            case 'D': return { color: '#f59e0b', label: txt.doubtful };
            case 'C': return { color: '#6366f1', label: txt.notInterested };
            default: return { color: '#64748b', label: txt.notAvailable };
        }
    };

    // --- Pagination & Filter Logic ---
    const filteredVoters = voters.filter(voter => {
        // Search term filter
        const matchesSearch = (voter.eng_f_name && voter.eng_f_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (voter.idcard_no && voter.idcard_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (voter.eng_surname && voter.eng_surname.toLowerCase().includes(searchTerm.toLowerCase()));

        // Status filter
        let matchesStatus = false;
        if (statusFilter === 'all') {
            matchesStatus = true;
        } else if (statusFilter === 'notAvailable') {
            // Not Available filter: match voters with status not in ['P', 'N', 'D', 'C']
            matchesStatus = !['P', 'N', 'D', 'C'].includes(voter.voter_status);
        } else {
            matchesStatus = voter.voter_status === statusFilter;
        }

        return matchesSearch && matchesStatus;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Get filter button label
    const getFilterButtonLabel = () => {
        if (statusFilter === 'all') return txt.allStatus;
        if (statusFilter === 'notAvailable') return txt.notAvailable;
        const status = getStatusStyles(statusFilter);
        return status.label;
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.filter-dropdown-container')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [showDropdown]);

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    return (
        <div className='app-container p-4 pb-5'>

            {/* Added Header Component Here */}
            <Header title={txt.pageTitle} />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Page Header with Premium Total Records Badge */}
            {!loading && (
                <div className="subtitle-container mt-3 mb-4">
                    <div className="subtitle-wrapper">
                        <p className="subtitle-text">
                            {lang === 'en' ? 'Phonebook:' : 'फोनबुक:'} <strong>{userInfo.name || admin_id || 'N/A'}</strong>
                        </p>
                        <div className="total-records-badge">
                            <div className="badge-icon-box">
                                <span className="badge-icon">📊</span>
                            </div>
                            <div className="badge-content">
                                <span className="badge-label">{txt.totalRecords}</span>
                                <span className="badge-count">{filteredVoters.length.toLocaleString()}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Search Bar with Filter Dropdown */}
            {voters.length > 0 && (
                <div className="filter-container-modern mb-4">
                    <div className="search-wrapper-modern">
                        <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="search-input-modern"
                            type="text"
                            placeholder={txt.filterPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    {/* Filter Dropdown Button */}
                    <div className="filter-dropdown-container">
                        <button
                            className="filter-dropdown-btn"
                            onClick={() => setShowDropdown(!showDropdown)}
                        >
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                            </svg>
                            <span>{txt.filterByStatus}</span>
                            <span className="filter-active-badge">{getFilterButtonLabel()}</span>
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>

                        {showDropdown && (
                            <div className="filter-dropdown-menu">
                                <div
                                    className={`filter-option ${statusFilter === 'all' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('all'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#64748b' }}></span>
                                    <span>{txt.allStatus}</span>
                                    {statusFilter === 'all' && <span className="filter-check">✓</span>}
                                </div>
                                <div
                                    className={`filter-option ${statusFilter === 'P' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('P'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#10b981' }}></span>
                                    <span>{txt.positive}</span>
                                    {statusFilter === 'P' && <span className="filter-check">✓</span>}
                                </div>
                                <div
                                    className={`filter-option ${statusFilter === 'N' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('N'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#ef4444' }}></span>
                                    <span>{txt.negative}</span>
                                    {statusFilter === 'N' && <span className="filter-check">✓</span>}
                                </div>
                                <div
                                    className={`filter-option ${statusFilter === 'D' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('D'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#f59e0b' }}></span>
                                    <span>{txt.doubtful}</span>
                                    {statusFilter === 'D' && <span className="filter-check">✓</span>}
                                </div>
                                <div
                                    className={`filter-option ${statusFilter === 'C' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('C'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#6366f1' }}></span>
                                    <span>{txt.notInterested}</span>
                                    {statusFilter === 'C' && <span className="filter-check">✓</span>}
                                </div>
                                <div
                                    className={`filter-option ${statusFilter === 'notAvailable' ? 'active' : ''}`}
                                    onClick={() => { setStatusFilter('notAvailable'); setShowDropdown(false); }}
                                >
                                    <span className="filter-option-dot" style={{ backgroundColor: '#64748b' }}></span>
                                    <span>{txt.notAvailable}</span>
                                    {statusFilter === 'notAvailable' && <span className="filter-check">✓</span>}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {loading ? (
                <div className="loader-wrapper text-center p-5">
                    <div className="spinner"></div>
                    <p className="mt-3">{txt.loadingData}</p>
                </div>
            ) : (
                <div style={{ marginBottom: filteredVoters.length > itemsPerPage ? '80px' : '0' }}>
                    <div className="row g-4">
                        {currentItems.length > 0 ? (
                            currentItems.map((voter, index) => {
                                const status = getStatusStyles(voter.voter_status);
                                return (
                                    <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                        <div className="voter-card-clean h-100">
                                            {/* Name Header with Status Badge in Top Right */}
                                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                                    <span className="voter-name-bold ms-2">
                                                        {voter.eng_f_name} {voter.eng_surname}
                                                    </span>
                                                </div>
                                                {/* Status Badge - Top Right Corner */}
                                                <span 
                                                    className="status-badge-top" 
                                                    style={{ 
                                                        backgroundColor: status.color,
                                                        color: '#ffffff',
                                                        padding: '3px 12px',
                                                        borderRadius: '20px',
                                                        fontSize: '11px',
                                                        fontWeight: '700',
                                                        whiteSpace: 'nowrap',
                                                        letterSpacing: '0.3px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                    }}
                                                >
                                                    {status.label}
                                                </span>
                                            </div>

                                            {/* Details Body - Removed Status Row */}
                                            <div className="voter-body position-relative">
                                                <div
                                                    className="map-icon-wrapper"
                                                    style={{ cursor: 'pointer', zIndex: 10 }}
                                                    title="View on Google Maps"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const address = voter.eng_localityid;
                                                        if (address && address !== "N/A") {
                                                            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
                                                        } else {
                                                            alert("Address not available!");
                                                        }
                                                    }}
                                                >
                                                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg" alt="Map" width="15" />
                                                </div>

                                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span className="label">{txt.mobile}</span>
                                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                    <svg
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditingVoter(voter);
                                                            setNewMobile(voter.contact_no || '');
                                                            setIsEditMobileOpen(true);
                                                        }}
                                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                    </svg>
                                                </div>
                                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>

                                                {voter.not_available_reason && (
                                                    <div className="info-row mt-1" style={{ background: '#fff7ed', padding: '4px 8px', borderRadius: '4px' }}>
                                                        <span className="label" style={{ color: '#9a3412' }}>Reason :</span>
                                                        <span className="value" style={{ color: '#9a3412' }}>{voter.not_available_reason}</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="voter-actions">
                                                <ActionButton icon="📞" color="#0ea5e9" label={txt.call}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                            alert("Mobile number is not available for this voter.");
                                                        }
                                                        else {
                                                            window.open(`tel:${voter.contact_no}`, '_blank');
                                                        }
                                                    }}

                                                />
                                                <ActionButton icon="✉️" color="#f59e0b" label={txt.text} onClick={() => handleSmsShare(voter)} />
                                                <WhatsappSlipButton voter={voter} />
                                                <PracharButton voter={voter} />
                                                <ActionButton
                                                    icon="🖨"
                                                    color="#f97316"
                                                    label={txt.print}
                                                    onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                                />
                                                <ActionButton icon="👨‍👩‍👧" color="#fbbf24" label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center text-muted p-5 w-100">{txt.noMembers}</div>
                        )}
                    </div>

                    {/* Fixed Pagination Controls */}
                    {filteredVoters.length > itemsPerPage && (
                        <div className="pagination-wrapper fixed-bottom-pagination">
                            <div className="pagination-content">
                                <button
                                    className="pagination-nav-btn"
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                </button>

                                <div className="page-numbers">
                                    {getPageNumbers().map((number, index) => (
                                        <React.Fragment key={index}>
                                            {number === '...' ? (
                                                <span className="page-dots">...</span>
                                            ) : (
                                                <button
                                                    className={`page-num-btn ${currentPage === number ? 'active' : ''}`}
                                                    onClick={() => paginate(number)}
                                                >
                                                    {number}
                                                </button>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>

                                <button
                                    className="pagination-nav-btn"
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <style jsx>{`
                /* Subtitle Styles - Premium Badge Layout */
                .subtitle-container {
                    margin-top: 8px;
                    margin-bottom: 20px;
                    position: relative;
                }
                .subtitle-wrapper {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 12px;
                }
                .subtitle-text {
                    font-size: 15px;
                    color: #334155;
                    margin: 0;
                    font-weight: 600;
                }
                .subtitle-container::after {
                    content: "";
                    display: block;
                    width: 60px;
                    height: 3px;
                    background: linear-gradient(to right, #2563eb, #60a5fa);
                    border-radius: 3px;
                    margin-top: 4px;
                }

                /* Premium Compact Total Record Card */
                .total-records-badge {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 8px 12px;
                    border-radius: 14px;
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: #fff;
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.18);
                    transition: 0.25s ease;
                    border: 1px solid rgba(255, 255, 255, 0.12);
                    min-width: 135px;
                }
                .total-records-badge:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);
                }
                .badge-icon-box {
                    width: 34px;
                    height: 34px;
                    border-radius: 10px;
                    background: rgba(255, 255, 255, 0.16);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-shrink: 0;
                }
                .badge-icon {
                    font-size: 15px;
                }
                .badge-content {
                    display: flex;
                    flex-direction: column;
                    line-height: 1.1;
                }
                .badge-label {
                    font-size: 9px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    color: rgba(255, 255, 255, 0.75);
                }
                .badge-count {
                    font-size: 18px;
                    font-weight: 800;
                    margin-top: 2px;
                    color: #fff;
                }
                
                .btn-reset { background: none; border: none; cursor: pointer; padding: 0; display: flex; flex-direction: column; align-items: center; }
                .spinner { width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .btn-back { background-color: white; color: #64748b; border: 1px solid #e2e8f0; padding: 6px 14px; border-radius: 8px; font-weight: 600; cursor: pointer; display: flex; align-items: center; transition: 0.2s; font-size: 0.9rem; }
                .btn-back:hover { background-color: #f8fafc; color: #1e293b; }
                
                /* Search Bar with Filter Styles */
                .filter-container-modern { 
                    display: flex; 
                    justify-content: space-between; 
                    align-items: center; 
                    gap: 16px;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
                }
                .search-wrapper-modern { 
                    position: relative; 
                    flex: 1;
                    max-width: 450px;
                }
                .search-icon-modern { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    width: 20px; 
                    height: 20px; 
                    color: #94a3b8; 
                    pointer-events: none; 
                    z-index: 1; 
                }
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 16px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 12px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    background-color: #ffffff; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                }
                .filter-dropdown-btn {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .filter-dropdown-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                .filter-active-badge {
                    background: #e2e8f0;
                    padding: 2px 8px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #475569;
                }
                .dropdown-arrow {
                    transition: transform 0.2s ease;
                }
                .dropdown-arrow.open {
                    transform: rotate(180deg);
                }
                .filter-dropdown-menu {
                    position: absolute;
                    top: calc(100% + 8px);
                    right: 0;
                    min-width: 210px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    z-index: 100;
                    overflow: hidden;
                }
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    cursor: pointer;
                    transition: background 0.2s ease;
                    font-size: 14px;
                    color: #1e293b;
                }
                .filter-option:hover {
                    background: #f8fafc;
                }
                .filter-option.active {
                    background: #eff6ff;
                }
                .filter-option-dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                }
                .filter-check {
                    margin-left: auto;
                    color: #10b981;
                    font-weight: bold;
                }

                /* Fixed Pagination Styles */
                .fixed-bottom-pagination { 
                    position: fixed; 
                    bottom: 0; 
                    left: 0; 
                    width: 100%; 
                    display: flex; 
                    justify-content: center; 
                    padding: 15px 0 20px 0; 
                    background: transparent; 
                    z-index: 1000;
                }
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; pointer-events: none; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 10px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); pointer-events: auto; }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; transition: all 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background: #EFF6FF; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 5px; align-items: center; }
                .page-num-btn { width: 32px; height: 32px; border-radius: 50%; border: 1px solid transparent; background: transparent; color: #475569; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn:hover { border-color: #2563EB; color: #2563EB; }
                .page-num-btn.active { background-color: #2563EB; color: white; border-color: #2563EB; box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3); }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }

                @media (max-width: 640px) {
                    .search-wrapper-modern { 
                        max-width: 100%;
                        flex: none;
                        width: 100%;
                    }
                    .filter-container-modern {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .filter-dropdown-btn {
                        justify-content: center;
                        width: 100%;
                    }
                    .filter-dropdown-menu {
                        right: auto;
                        left: 0;
                        width: 100%;
                    }
                    .subtitle-wrapper {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                    .total-records-badge {
                        align-self: flex-start;
                    }
                    .subtitle-container::after {
                        display: none;
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default PhonebookWiseSurveyVoters;